import { gql } from '@apollo/client';

export const SAVE_FAIR_CODE = gql`
    mutation saveFairCode($code: String!) {
        saveFairCode(code: $code) {
            code
        }
    }
`;
